import latinize from 'latinize';
import { toLower, toUpper } from 'lodash';

export {
  latinize,
  toLower,
  toUpper,
};

export default {
  latinize,
  toLower,
  toUpper,
};
